if !!window.PasswordPolicy

  PasswordPolicy.passed = () ->
    passed = true
    for validation in Object.keys(@validations)
      unless !!@validations[validation].checked
        passed = false
        break
    passed

  PasswordPolicy.init = (password_element_selector,password_confirmation_element_selector,current_password_selector) ->
    @currentPasswordElement = $(current_password_selector)
    @passwordElement = $(password_element_selector)
    @passwordConfirmationElement = $(password_confirmation_element_selector)
    @passwordElement.keyup ->
      PasswordPolicy.validatePassword()
      PasswordPolicy.validatePasswordConfirmation()
      PasswordPolicy.validatePreviousPassword() if !!PasswordPolicy.validations["current_password"]
    @passwordConfirmationElement.keyup ->
      PasswordPolicy.validatePasswordConfirmation()
    if !!@validations["current_password"]
      @currentPasswordElement.keyup ->
        PasswordPolicy.validatePreviousPassword()
        PasswordPolicy.validatePreviousPasswordPresence()
    $("#edit_user").submit (event) ->
      unless PasswordPolicy.passed()
        event.preventDefault()
    $("#new_user").submit (event) ->
      unless PasswordPolicy.passed()
        event.preventDefault()


  PasswordPolicy.checkProperty = (property) ->
    @validations[property].checked = true if !!@validations[property]
    $("##{property}").removeClass("failed")
    $("##{property}").addClass("passed")


  PasswordPolicy.unCheckProperty = (property) ->
    @validations[property].checked = false if !!@validations[property]
    $("##{property}").removeClass("passed")
    $("##{property}").addClass("failed")

  PasswordPolicy.validatePassword = () ->
    password = @passwordElement.val()
    if !!password
      for validation in Object.keys(@validations)
        switch validation
          when "length"
            if password.length < @validations[validation].value then @unCheckProperty(validation) else @checkProperty(validation)
          when "special_characters"
            regex = /^(.*[$!@#%^&*_=?+<>])/
            if regex.test(password) then @checkProperty(validation) else @unCheckProperty(validation)
          when "numbers"
            regex = /^(.*[\d])/
            if regex.test(password) then @checkProperty(validation) else @unCheckProperty(validation)
          when "capital_letters"
            regex = /^(.*[A-Z])/
            if regex.test(password) then @checkProperty(validation) else @unCheckProperty(validation)
          when "lowercase_letters"
            regex = /^(.*[a-z])/
            if regex.test(password) then @checkProperty(validation) else @unCheckProperty(validation)
    else
      for key in Object.keys(@validations)
        $("##{key}").removeClass("passed").addClass("failed") unless key == "current_password" || key == "current_password_present"


  PasswordPolicy.validatePasswordConfirmation = () ->
      password_confirmation = @passwordConfirmationElement.val()
      password = @passwordElement.val()
      if !!password && !!password_confirmation
        if password == password_confirmation
          @checkProperty("password_confirmation")
        else
          @unCheckProperty("password_confirmation")
      else
        @unCheckProperty("password_confirmation")

  PasswordPolicy.validatePreviousPassword = () ->
      current_password = @currentPasswordElement.val()
      password = @passwordElement.val()
      if !!password && !!current_password
        if password == current_password
          @unCheckProperty("current_password")
        else
          @checkProperty("current_password")
      else
        @unCheckProperty("current_password")

  PasswordPolicy.validatePreviousPasswordPresence = () ->
      current_password = @currentPasswordElement.val()
      unless !!current_password
        @unCheckProperty("current_password_present")
      else
        @checkProperty("current_password_present")

  PasswordPolicy.init("#user_password","#user_password_confirmation","#user_current_password")
